export const THEME_STORAGE_KEY = 'savinfy-theme-mode'

export const ThemeModes = {
  system: 'system',
  light: 'light',
  dark: 'dark',
}

export function isThemeMode(value) {
  return value === ThemeModes.system || value === ThemeModes.light || value === ThemeModes.dark
}

export function getStoredThemeMode() {
  if (typeof window === 'undefined') return ThemeModes.system
  const raw = window.localStorage.getItem(THEME_STORAGE_KEY)
  return isThemeMode(raw) ? raw : ThemeModes.system
}

export function getSystemTheme() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return ThemeModes.light
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? ThemeModes.dark
    : ThemeModes.light
}

export function resolveTheme(mode) {
  return mode === ThemeModes.system ? getSystemTheme() : mode
}
